import React               from 'react';
import { Route, Routes } from 'react-router-dom';
import { Settings }        from './Settings';

export const SettingsRoutes = () => (
  <Routes>
    <Route
      path="/:tab?/:subPage"
      element={<Settings />}
    />
  </Routes>
);
